module.exports = __webpack_public_path__ + "gb.svg?a95b4dcc4880d80185382cbcbc6d784e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gb.svg
// module id = 1252
// module chunks = 27